<div class="content-area">
  <!--<app-loading-component *ngIf="isLoading"></app-loading-component>-->
  <app-base-grid-page
    [posts]="posts"
    [isLoading]="isLoading"
    [itemsCount]="itemsCount"
    [pagesCount]="pagesCount"
    thumbnailType="SEARCH"
    [title]="title"
    searchPlaceholder="Caută în tot site-ul"
    (getData)="getData($event)"
  ></app-base-grid-page>

</div>
